export default {
  EmptyState: {
    title: 'Ajoutez votre premier restaurant',
    description:
      "Vous n'avez encore aucun restaurant. Créez-en un pour commencer la configuration et prendre des commandes.",
    cta: 'Nouveau restaurant',
  },
};
